import { Component } from "react";

import PasswordEditForm from "../Authentication/PasswordEditForm";

class PasswordEditFormRoute extends Component {
  render() {
    return <PasswordEditForm {...this.props} />;
  }
}

export default PasswordEditFormRoute;
